module.exports = __webpack_public_path__ + "static/img/415.fc69b939.jpg";